import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-[900px] mx-auto px-6 py-32 text-center">
      <p className="overline">404</p>
      <h1 className="mt-6 font-serif text-6xl md:text-7xl tracking-tight text-[#2A2626]">
        This page has drifted away.
      </h1>
      <p className="mt-6 text-[#5C564F]">
        Let&rsquo;s find you something beautiful instead.
      </p>
      <Link
        to="/"
        className="mt-10 inline-block bg-[#2A2626] text-[#FAF8F5] px-10 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-[#3A3632] transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
